import { createAction } from 'redux-actions'
import * as constants from './constants'

export const typing = createAction(constants.TYPING)
export const typingFinished = createAction(constants.TYPING_FINISHED)

export const userTyping = createAction(constants.USER_TYPING)
export const userTypingFinished = createAction(constants.USER_TYPING_FINISHED)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/typing/actions.js